import React, { Component } from 'react';
import Download from './../assets/img/download.png';
import APIHandler from './../utilities/apiHandler.js';
import FileSaver from 'file-saver';
import CircularProgress from '@material-ui/core/CircularProgress';


export default class DownloadFile extends Component{
	constructor(props){
		super(props);
		this.state = {
			loading: false
		}
		this.downloadFile = this.downloadFile.bind(this);
	}

	downloadFile() {
		if(this.props.url) {
			this.setState({loading: true})
			APIHandler.fileDownloadHttpGet(this.props.url)
			.then(response => {
				return response.data.blob().then(data => {
					var blob = new Blob([data], {
                    	type: response.mime
                	});
                	FileSaver.saveAs(blob, response.name);
				})
			}).catch(error => {
				if(this.props.errorCallback) {
					this.props.errorCallback(error);
				}
			}).finally(data => {
				this.setState({loading: false})
			})
		}
	}

	render() {
		return(
			<div style={{display: 'table'}}>
				<div className="pull-left">
					<button className="btn btn-default"  disabled={this.state.loading} onClick={this.downloadFile}><img src={Download} width="20px" alt="download"/> {this.props.title}</button>
				</div>
				{(this.state.loading)?
				<div className="pull-left">
					<CircularProgress size={30} thickness={5} style={{color:'#212121'}} />
				</div>:null
				}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/commons/DownloadFile.js